module.exports = __webpack_public_path__ + "fonts/iconfont.52be805.woff";